module.exports = __webpack_public_path__ + "img/movr_logo.1b20b187.png";